import { OrigemID } from './origem.id';

/** Origens dos dados da aplicação */
export interface Origem {
    id: OrigemID;
    nome: string;
    possuiCanalVenda: boolean;
    icon: string;
}

export namespace Origem {
    /** Origem Desconhecida */
    export const ORIGEM_DESCONHECIDA: Origem = {
        id: OrigemID.DESCONHECIDA,
        nome: 'Desconhecida',
        possuiCanalVenda: false,
        icon: 'far fa-question-circle'
    };

    /** Origem Campanha */
    export const ORIGEM_CAMPANHA: Origem = {
        id: OrigemID.CAMPANHA,
        nome: 'Campanha',
        possuiCanalVenda: true,
        icon: 'fas fa-bullhorn'
    };

    /** Origem Indicação */
    export const ORIGEM_INDICACAO: Origem = {
        id: OrigemID.INDICACAO,
        nome: 'Indicação',
        possuiCanalVenda: false,
        icon: 'fas fa-people-arrows'
    };

    /** Origem Mídia Social */
    export const ORIGEM_MIDIA_SOCIAL: Origem = {
        id: OrigemID.MIDIA_SOCIAL,
        nome: 'Mídia Social',
        possuiCanalVenda: false,
        icon: 'far fa-heart'
    };

    /** Origem Pesquisa Orgânica */
    export const ORIGEM_PESQUISA_ORGANICA: Origem = {
        id: OrigemID.PESQUISA_ORGANICA,
        nome: 'Pesquisa Orgânica',
        possuiCanalVenda: false,
        icon: 'fas fa-search'
    };

    /** Origem Prospecção Ativa */
    export const ORIGEM_PROSPECCAO_ATIVA: Origem = {
        id: OrigemID.PROSPECCAO_ATIVA,
        nome: 'Prospecção Ativa',
        possuiCanalVenda: false,
        icon: 'fas fa-street-view'
    };

    /** Origem Site */
    export const ORIGEM_SITE: Origem = {
        id: OrigemID.SITE,
        nome: 'Site',
        possuiCanalVenda: false,
        icon: 'fas fa-globe'
    };

    /** Origem E-commerce */
    export const ORIGEM_ECOMMERCE: Origem = {
        id: OrigemID.ECOMMERCE,
        nome: 'E-commerce',
        possuiCanalVenda: true,
        icon: 'fas fa-shopping-cart'
    };

    /** Origem Outra */
    export const ORIGEM_OUTRA: Origem = {
        id: OrigemID.OUTRA,
        nome: 'Outra',
        possuiCanalVenda: false,
        icon: 'far fa-question-circle'
    };

    /** Retorna todas as origens da aplicação */
    export function getAll(): Origem[] {
        return [
            ORIGEM_CAMPANHA,
            ORIGEM_INDICACAO,
            ORIGEM_MIDIA_SOCIAL,
            ORIGEM_PESQUISA_ORGANICA,
            ORIGEM_PROSPECCAO_ATIVA,
            ORIGEM_SITE,
            ORIGEM_ECOMMERCE,
            ORIGEM_OUTRA
        ];
    }

    /** Obtém a origem pelo id */
    export function getById(id: number): Origem | undefined {
        return getAll().find(origem => origem.id === id);
    }
}
